// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._932a54{margin-left:.5em}.bbd476{font-size:.875em}.bbd476 small{display:block;margin-bottom:.25em}._561ab8{font-size:.75em}", ""]);
// Exports
exports.locals = {
	"tag": "_932a54",
	"units": "bbd476",
	"isNested": "_561ab8"
};
module.exports = exports;
